'use strict';
var parent = require('../../es/symbol');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/stable/symbol/index.js
// module id = 1557
// module chunks = 0